const borders = {
  radius: 5,
  radiusButton: 30,
  height: 1,
};

export default borders;
